<template>
    <div class="roleManage">
        <!-- 标题 -->
        <Title-Box :top-title="topTitle"></Title-Box>

        <!-- tab切换-切换 -->
        <ul class="tabBox boxs clearfix">
            <li v-for="(item,index) in tabData.textArr" @click="tabLi(index)" :class="{on:tabData.nowIndex==index}">{{item}}
            </li>
        </ul>

        <!-- tab角色管理 -->
        <div class="tabContent manageArea boxs" v-if="tabData.nowIndex == 0">
            <!-- tab角色管理-筛选框 -->
            <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
                <template slot="otherCom">

                    <el-form-item>
                        <el-input
                                v-model="searchForm.name"
                                placeholder="输入角色名称"
                                @keyup.enter.native="handleSearch"
                                maxlength="30" size="medium" clearable
                                @input="e => searchForm.name = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-input
                                v-model="searchForm.code"
                                placeholder="输入角色编码"
                                @keyup.enter.native="handleSearch"
                                maxlength="30" size="medium" clearable
                                @input="e => searchForm.code = validForbid(e)"
                        >
                        </el-input>
                    </el-form-item>

                </template>
            </sr-filter>


            <!-- tab角色管理-表格 -->
            <div class="botTable tableTheadGray boxs">
                <div class="tableTop">
                    <span class="leTableTit">角色列表</span>
                    <div class="rightBox">
                        <!-- 添加角色按钮 -->
                        <el-button @click="handleAddDialog()" class="greenBtn" icon="el-icon-plus" size="small">新建角色</el-button>
                        <!-- 导出按钮 -->
                        <el-button @click="tableExport()" class="orangeBtn" icon="el-icon-upload2" size="small">导出</el-button>
                    </div>
                </div>
                <el-table :data="tableData"
                            ref="multipleTable"
                            style="width: 100%;"
                            max-height="600"
                            border
                            fit
                            highlight-current-row
                            tooltip-effect="dark"
                >
                    <!-- 这是列表前面的多选框 -->
                    <!-- <el-table-column type="selection" align="center" width="35"></el-table-column> -->

                    <el-table-column label="角色编码" prop="CODE" min-width="190" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="角色名称" prop="NAME" min-width="190" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="授权人数" prop="USER_COUNT" width="90" header-align="center" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span class="greenText" @click="showAuthDetailDialog(scope)">{{scope.row.USER_COUNT}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="创建人" prop="CREATE_NAME" min-width="130" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="创建时间" prop="CREATE_TIME" width="190" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="备注" prop="NOTE" width="190" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="操作" fixed="right" width="200" header-align="center" align="center"
                                    show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button @click="showEditDialog(scope)" class="greenText"
                                        icon="fa fa-pencil" type="text" title="编辑"
                                        v-if="scope.row.TYPE_ID == '1'"
                            >编辑</el-button>
                            <el-button @click="showAuthDialog(scope)" class="greenText"
                                        icon="el-icon-success" type="text" title="授权"
                            >授权</el-button>
                            <el-button @click="showDelDialog(scope)" class="orangeText"
                                        icon="fa fa-trash" type="text" title="删除"
                                        v-if="scope.row.TYPE_ID == '1'"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pageBox boxs">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="searchForm.page" :page-sizes="[10, 20, 30]" :page-size="searchForm.rows"
                                layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>

            </div>

        </div>

        <!-- tab角色权限配置 -->
        <div class="tabContent mainBox boxs" v-if="tabData.nowIndex == 1">
            <!-- tab角色权限配置-左边 -->
            <div class="le_main boxs">
                <!-- 标题 -->
                <p class="titleBox boxs">
                    <i class="roleIcon"></i>
                    <span>角色列表</span>
                </p>

                <!-- tab角色列表 -->
                <div class="content roleBox boxs">
                    <ul class="roleUlBox">
                        <li v-for="(item,index) in roleData.roleArr"  @click="changeRole(index, item.CODE)" :class="{on:roleData.roleIndex==index}">
                            <i class="roleHead"></i>
                            <span class="roleName">{{item.NAME}}</span>
                        </li>
                    </ul>
                </div>

            </div>

            <!-- tab角色权限配置-右边树 -->
            <div class="ri_main boxs">
                <!-- 标题+搜索框 -->
                <div class="topBox boxs">
                    <span class="leTit">授权选项</span>
                    <div class="riFilter">
                        <el-button class="btn-search" @click="finallyAuth" size="small" title="提交授权">提交授权</el-button>

                                <!-- v-model="searchAuthRoleForm.parentName" -->
                        <!-- <el-input
                                placeholder="请搜索"
                                @keyup.enter.native="searchTree"
                                maxlength="25" size="small" clearable
                                @input="e => searchAuthRoleForm.parentName = validForbid(e)"
                        >
                        </el-input>
                        <el-button class="btn-search" @click="searchTree" size="small" title="搜索"><i class="el-icon-search"></i></el-button> -->
                    </div>
                </div>

                <!-- 授权选项区域 -->
                <div class="treeContent boxs">
                    <!-- node-key="id" -->
                    <!-- node-key="value" -->
                    <el-tree 
                        :data="authTreeData" 
                        :props="authTreeProps" 
                        ref="tree"
                        :node-key="nodeKey"
                        @node-click="authTreeClick"
                        :render-after-expand="defaultFalse"
                        highlight-current
                        show-checkbox
                        @check-change="authTreeCheckChange"
                        @current-change="authCurrentCheckChange"
                    >
                    </el-tree>

                </div>

            </div>
        </div>





        <!-- 弹窗 -->
        <el-dialog width="460px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
                :before-close="beforeClose" :close-on-click-modal=false :show-close="false">
            <el-form ref="form" :rules="rules" :model="postForm" label-width="80px">

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="角色名称" prop="name">
                            <el-input
                                    v-model="postForm.name"
                                    placeholder="请输入角色名称"
                                    maxlength="30" clearable
                                    @input="e => postForm.name = validForbid(e)"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="角色编码" prop="code">
                            <el-input
                                    v-model="postForm.code"
                                    placeholder="请输入角色编码"
                                    maxlength="30" clearable
                                    v-if="dialogTitle == 'add'"
                                    @input="e => postForm.code = validForbid(e)"
                            >
                            </el-input>
                            <el-input
                                    v-model="postForm.code"
                                    placeholder="请输入角色编码"
                                    maxlength="30" clearable
                                    v-if="dialogTitle == 'edit'"
                                    disabled 
                                    @input="e => postForm.code = validForbid(e)"
                            >
                                    <!-- readonly  -->
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" prop="note">
                            <el-input
                                    v-model="postForm.note"
                                    placeholder="请输入备注"
                                    maxlength="180"
                                    clearable
                                    type="textarea"
                                    :rows="3"
                                    @input="e => postForm.note = validForbid(e)"
                            >
                            <!-- @input="e => postForm.note = validForbid(e)"：限制输入特殊字符 -->
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>

            <span slot="footer" class="dialog-footer flex-col">
                <div class="flex-row jus-c">
                    <button @click="beforeClose" class="butStyle cancelBtn">取 消</button>
                    <button @click="validateForm" class="butStyle refuseOBtn">确 定</button>
                </div>
            </span>
        </el-dialog>


        <!-- 授权弹窗 -->
        <el-dialog width="620px" :title='"授权"' :visible.sync="authDialogFormVisible" @close="closeAuthDialog"
                :before-close="beforeCloseAuth" :close-on-click-modal=false :show-close="false">

            <!-- 授权弹窗-筛选条件 -->
            <div class="filtBox2">
                <el-form :inline="true" label-width="100%">
                    <slot name="otherCom">
                        <el-form-item>
                            <el-input
                                    v-model="searchAuthRoleForm.userAccountOrName"
                                    placeholder="请输入用户账号/名称"
                                    @keyup.enter.native="handleSearch2"
                                    maxlength="30" size="medium" clearable
                                    @input="e => searchAuthRoleForm.userAccountOrName = validForbid(e)"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input
                                    v-model="searchAuthRoleForm.parentName"
                                    placeholder="请输入所属会员"
                                    @keyup.enter.native="handleSearch2"
                                    maxlength="30" size="medium" clearable
                                    @input="e => searchAuthRoleForm.parentName = validForbid(e)"
                            >
                            </el-input>
                        </el-form-item>
                        
                    </slot>
                    <el-form-item class="btnArea">
                        <el-button class="btn-search" @click="handleSearch2" size="medium" title="搜索"><i class="el-icon-search"></i></el-button>
                        <el-button class="btn-reset" @click="handleReset2" size="medium" title="重置"><i class="el-icon-refresh"></i></el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 授权弹窗-表格 -->
            <div class="botTable tableTheadGray boxs">
                <el-table :data="authRoleTableData"
                            ref="authDTable"
                            style="width: 100%;"
                            max-height="433"
                            border
                            fit
                            highlight-current-row
                            tooltip-effect="dark"
                            @selection-change="selsChange" 
                            @select="selectOneSel" 
                            @row-click="handleTableChange"
                >
                    <!-- 这是列表前面的多选框 -->
                    <el-table-column type="selection" align="center" width="35"></el-table-column>

                    <el-table-column label="人员账号" prop="ACCOUNT" min-width="180" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="人员姓名" prop="NAME" min-width="120" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="所属会员" prop="PARENT_MEMBER" min-width="120" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                </el-table>
                <div class="pageBox2 boxs">
                    <span>已选<span class="greenText">{{checkedGouArrDataTotal}}</span>名</span>
                    <el-pagination :pager-count="5" @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
                                :current-page="searchAuthRoleForm.page" :page-sizes="[8, 20, 30]" :page-size="searchAuthRoleForm.rows"
                                layout="total, sizes, prev, pager, next" :total="authRoleTotal">
                    </el-pagination>
                    <!-- <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
                                :current-page="searchAuthRoleForm.page" :page-sizes="[8, 16, 24, 32]" :page-size="searchAuthRoleForm.rows"
                                layout="total, sizes, prev, pager, next, jumper" :total="authRoleTotal">
                    </el-pagination> -->
                </div>

            </div>


            <!-- 授权弹窗-底部按钮 -->
            <span slot="footer" class="dialog-footer flex-col">
                <div class="flex-row jus-c">
                    <button @click="beforeCloseAuth" class="butStyle cancelBtn">取 消</button>
                    <button @click="validateAuthForm" class="butStyle refuseOBtn">确 定</button>
                </div>
            </span>

        </el-dialog>


        <!-- 授权详情弹窗 -->
        <el-dialog width="600px" :title='"授权详情"' :visible.sync="authDetailDialogFormVisible" @close="closeAuthDetailDialog"
                :before-close="beforeCloseAuthDetail" :close-on-click-modal=false :show-close="false">

            <!-- 授权详情弹窗-筛选条件 -->
            <div class="filtBox2">
                <el-form :inline="true" label-width="100%">
                    <slot name="otherCom">
                        <el-form-item>
                            <el-input
                                    v-model="searchAuthDetailForm.userAccountOrName"
                                    placeholder="请输入用户账号/名称"
                                    @keyup.enter.native="handleSearch3"
                                    maxlength="30" size="medium" clearable
                                    @input="e => searchAuthDetailForm.userAccountOrName = validForbid(e)"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input
                                    v-model="searchAuthDetailForm.parentName"
                                    placeholder="请输入所属会员"
                                    @keyup.enter.native="handleSearch3"
                                    maxlength="30" size="medium" clearable
                                    @input="e => searchAuthDetailForm.parentName = validForbid(e)"
                            >
                            </el-input>
                        </el-form-item>
                        
                    </slot>
                    <el-form-item class="btnArea">
                        <el-button class="btn-search" @click="handleSearch3" size="medium" title="搜索"><i class="el-icon-search"></i></el-button>
                        <el-button class="btn-reset" @click="handleReset3" size="medium" title="重置"><i class="el-icon-refresh"></i></el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 授权详情弹窗-表格 -->
            <div class="botTable tableTheadGray boxs">
                <el-table :data="authRoleDetailTableData"
                            ref="authDetailTable"
                            style="width: 100%;"
                            max-height="433"
                            border
                            fit
                            highlight-current-row
                            tooltip-effect="dark"
                >
                    <el-table-column label="人员账号" prop="ACCOUNT" min-width="180" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="人员姓名" prop="NAME" min-width="120" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column label="所属会员" prop="PARENT_MEMBER" min-width="120" header-align="center" align="center" show-overflow-tooltip>
                    </el-table-column>

                </el-table>
                <div class="pageBox boxs">
                    <el-pagination :pager-count="5" @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
                                :current-page="searchAuthDetailForm.page" :page-sizes="[8, 20, 30]" :page-size="searchAuthDetailForm.rows"
                                layout="total, sizes, prev, pager, next" :total="authRoleDetailTotal">
                    </el-pagination>
                    <!-- <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
                                :current-page="searchAuthDetailForm.page" :page-sizes="[8, 16, 24, 32]" :page-size="searchAuthDetailForm.rows"
                                layout="total, sizes, prev, pager, next, jumper" :total="authRoleDetailTotal">
                    </el-pagination> -->
                </div>

            </div>


            <!-- 授权详情弹窗-底部按钮 -->
            <span slot="footer" class="dialog-footer flex-col">
                <div class="flex-row jus-c">
                    <button @click="beforeCloseAuthDetail" class="butStyle cancelBtn">取 消</button>
                    <button @click="validateAuthDetailForm" class="butStyle refuseOBtn">确 定</button>
                </div>
            </span>

        </el-dialog>

    </div>
</template>

<script>
import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
import SrFilter from '@/components/Common/Filter/Filter';
import {objectToQueryString} from '@/utils/commonUtils.js';
import {
    getRoleListReq, //角色管理表格数据
    addOrEditRoleReq, //添加/编辑角色
    delRoleReq, //删除角色
    getAuthDetailRoleReq, //授权详情
    authRoleReq, //给用户分配角色（授权）
    getRoleByCodeReq, //根据角色返回用户（角色拥有的用户会有标识） 
    getRoleAuthTotalReq, //根据角色返回用户数
    getRoleDetailReq, //根据角色编码获取角色信息

    getAllRoleDataReq, //获取所有角色
    getAuthTreeReq, //授权菜单树形数据
    getAuthIsGouByRoleReq, //根据用户获取用户拥有的功能权限 (根据点击左边的角色获取右面要显示勾选数据)
    cancelAuthReq, //取消授权
    addAuthReq, //授权
    confirmAddAuthReq, //确定授权
} from '@/api/System/roleManage.js';




// tab角色权限配置-授权、取消授权的请求参数
const defaultAuthRoleParma = {
    group_code: null, //角色编码（通过点击左边角色列表获取）
    res_path: null, //模块路径值（通过勾选右边授权树节点获取，此参数只有最后一层树节点才有）
    module_path: null, //模块id（通过勾选右边授权树节点获取）
    // module_path: [
    //     {'id1'},
    //     {'id2'},
    // ],
    // module_path: 'id1,id2'
}




// 角色授权详情-表格的条件-筛选栏
const defaultSearchAuthDetailForm = {
    userAccountOrName: '', //用户账号/名称
    parentName: '', //所属会员
    code: '', //角色编码
    page: 1, //当前页码
    rows: 8, //每页条数
}

// 角色授权-表格的条件-筛选栏
const defaultSearchAuthRoleForm = {
    userAccountOrName: '', //用户账号/名称
    parentName: '', //所属会员
    code: '', //角色编码
    page: 1, //当前页码
    rows: 8, //每页条数
}

// 角色授权-提交的数据
const defaultSubmitForm = {
    code: null, //角色编码
    rightBox: null, //需要授权的用户数组
    userId: null, //用户id
    // rightBox: [
    //     {userId: ''},
    //     {userId: ''},
    // ]
}


// 弹窗的数据
const defaultPostForm = {
    code: null, //角色编码
    name: null, //角色名称
    note: null, //备注
}

// 搜索表格的条件-筛选栏
const defaultSearchForm = {
    name: '', //角色名称
    code: '', //编码
    page: 1, //当前页码
    rows: 10, //每页条数
}

export default {
    name: "RoleManageIndex",
    data() {
        return {
            //标题
            topTitle: {
                title: '角色管理',
                subTit: ''
            },

            // tab切换
            tabData: {
                textArr: ['角色管理', '角色权限配置'],
                nowIndex: 0
            },

            // 表格搜索条件
            searchForm: Object.assign({}, defaultSearchForm),

            // 表格数据
            tableData: [],
            // 表格数据总数
            total: 0,

            // 弹窗数据
            postForm: Object.assign({}, defaultPostForm),
            // 添加/编辑窗口是否显示
            dialogFormVisible: false,
            // 弹窗标题
            dialogMap: {
                add: '添加角色',
                edit: '编辑角色'
            },
            dialogTitle: '',
            rules: {
                name: [{required: true, message: '请输入角色名称', trigger: 'blur'}],
                code: [{required: true, message: '请输入角色编码', trigger: 'blur'}],
            },


            // 授权窗口是否显示
            authDialogFormVisible: false,
            // 弹窗标题
            authDialogTitle: '授权',

            // 角色授权表格数据
            authRoleTableData: [],
            // 角色授权表格数据总数
            authRoleTotal: 0,
            // 角色授权表格搜索条件
            searchAuthRoleForm: Object.assign({}, defaultSearchAuthRoleForm),
            // 角色授权提交参数
            authSubmitForm: Object.assign({}, defaultSubmitForm),
            // 角色授权表格打开时已勾选数据
            checkedGouArrData: [],
            // 角色授权表格打开时已勾选数据总数
            checkedGouArrDataTotalForTable: 0,
            // 角色授权表格当前已勾选数据总数
            checkedGouArrDataTotal: 0,
            // 角色授权表格勾选数组
            sels: [],
            // 添加授权的人员数组
            addAuthPersonnel: [],
            // 取消授权的人员数组
            delAuthPersonnel: [],


            
            // 授权详情窗口是否显示
            authDetailDialogFormVisible: false,
            // 弹窗标题
            authDetailDialogTitle: '授权详情',

            // 角色授权详情表格数据
            authRoleDetailTableData: [],
            // 角色授权详情表格数据总数
            authRoleDetailTotal: 0,
            // 角色授权详情表格搜索条件
            searchAuthDetailForm: Object.assign({}, defaultSearchAuthDetailForm),


            // 以下是角色权限配置-------以下是角色权限配置-------以下是角色权限配置-------以下是角色权限配置-------以下是角色权限配置-------
            // 角色数据
            roleData: {
                roleArr: [],
                roleIndex: null,
                // roleIndex: 0,
            },
            // 授权树数据(根据角色获取)
            authTreeData: [],
            // 会员树数据格式
            authTreeProps: {
                children: 'submenus',
                label: 'name', //模块名称
                labelId: 'id', //模块id
                // value: 'value' //模块路径值
            },
            nodeKey: 'id',
            // tab角色权限配置-授权、取消授权的请求参数
            authRoleParma: Object.assign({}, defaultAuthRoleParma),
            // tab角色权限配置-授权、取消授权的请求参数数组
            authRoleParmaArr: [],

            // tab角色权限配置-授权、取消授权的请求参数数组中的group_code
            authGroupCode: null,
            // tab角色权限配置-授权的请求参数数组中的res_path，module_path
            authAddArr: [],
            // tab角色权限配置-取消授权的请求参数数组中的res_path，module_path
            authDelArr: [],
            defaultFalse: false,


        }
    },
    components: {
        TitleBox,
        SrFilter
    },
    created () {
        if(this.tabData.nowIndex == 0) {
            this.getRoleList()
        } else if (this.tabData.nowIndex == 1) {
            this.getAllRoleData()
            this.getAuthTree()
        }
    },
    methods: {
        // 顶部菜单切换
        tabLi(nowIndex) {
            // console.log(nowIndex)
            // 0:'角色管理', 1:'角色权限配置'
            this.tabData.nowIndex = nowIndex;

            if(this.tabData.nowIndex == 0) {
                this.getRoleList()
            } else if (this.tabData.nowIndex == 1) {
                this.getAllRoleData()
                this.getAuthTree()
            }
        },
        // 导出表格数据
        tableExport() {
            var url = `${this.$baseUrl}/!org/usergroup/~query/Q_USERGROUP_LIST.NEW?result=excel&${objectToQueryString(this.searchForm)}`;
            // console.log(url);
            window.open(url, '_blank');

            // window.open(`http://localhost:8080/esaleb-server/!org/usergroup/~query/Q_USERGROUP_LIST.NEW?result=excel&${objectToQueryString(this.searchForm)}`, '_blank');
        },


        // 获取角色表格数据
        getRoleList () {
            getRoleListReq(this.searchForm)
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    this.tableData = resp.body.rows
                    this.total = parseInt(resp.body.total)

                    // res = JSON.parse(unescape(JSON.stringify(res)))
    //   console.log('res', res)
    //   var rows = unescape(JSON.stringify(res))
    //   console.log('rows', rows)
    //   // res = JSON.parse(rows.replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\"/g, ""));
    //   res = rows.replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\"/g, "");
    //   console.log('res22', res)
                })
                .catch(e => {
                    console.log(e);
                })
        },


        // 列表过滤查询
        handleSearch() {
            this.searchForm.page = 1
            this.getRoleList()
        },
        // 搜索重置（清空）
        handleReset() {
            // 初始化参数
            this.searchForm = Object.assign({}, defaultSearchForm)
            // 获取表格数据
            this.getRoleList()
        },
        // 列表每页条数变了
        handleSizeChange(val) {
            this.searchForm.rows = val
            this.getRoleList()
        },
        // 列表当前页码变了
        handleCurrentChange(val) {
            this.searchForm.page = val
            this.getRoleList()
        },



        // 列表勾选(当用户手动勾选数据行的 Checkbox 时触发的事件)
        // selection：当前所有选中的数组
        // row：当前勾选变化的一行
        selectOneSel (selection, row) {
            // console.log('触发勾选-row', row)
            // console.log('selectOneSel-selection', selection)
            // console.log('selectOneSel-row', row)

            let fd = selection.indexOf(row)
            let fd1 = this.addAuthPersonnel.indexOf(row)
            let fd2 = this.delAuthPersonnel.indexOf(row)
            // let fd3 = this.checkedGouArrData.indexOf(row)
            if(fd != -1){
                // 如果是添加勾选操作
                if(fd1 == -1) {
                    // console.log('添加勾选-row', row)
                    // 只有当添加授权角色数组里面没有该对象时才添加进去
                    this.addAuthPersonnel.push(row);
                    this.delAuthPersonnel.splice(fd2, 1);
                }
            } else if(fd == -1){
                // 如果是取消勾选操作
                if(fd2 == -1) {
                    // console.log('取消勾选-row', row)
                    // 只有当取消授权角色数组里面没有该对象时才添加进去
                    this.addAuthPersonnel.splice(fd1, 1);
                    this.delAuthPersonnel.push(row);
                }
                
            }

            // 显示“已勾选”的数量
            this.checkedGouArrDataTotal = this.checkedGouArrDataTotalForTable + this.addAuthPersonnel.length - this.delAuthPersonnel.length

            console.log('addAuthPersonnel', this.addAuthPersonnel)
            console.log('delAuthPersonnel', this.delAuthPersonnel)

        },
        // 列表勾选(当选择项发生变化时会触发该事件)
        selsChange (val) {
            this.sels = val
            // 显示“已勾选”的数量
            // this.checkedGouArrDataTotal = val.length
            // console.log('selsChange-val', val)
            // console.log('selsChange-length', val.length)
        },
        // 点击表格某一行
        handleTableChange(row, event, column) {
            // toggleRowSelection用于切换某一行的选中状态
            // this.$refs.multipleTable.toggleRowSelection(row)
            // console.log('handleTableChange-row', row)
            // console.log('handleTableChange-event', event)
            // console.log('handleTableChange-column', column)
        },
        // 批量处理
        batchOpt (value) {
            this.batchValue = value
        },
        // 批量处理确定按钮
        batchComfirm (value) {
        },



        // 弹出“添加角色”窗口
        handleAddDialog() {
            this.dialogTitle = 'add'
            this.dialogFormVisible = true
            
        },
        // 弹出“编辑角色”窗口
        showEditDialog(data) {
            this.dialogTitle = 'edit'
            this.dialogFormVisible = true

            const rowData = JSON.parse(JSON.stringify(data.row))
            this.postForm.name = rowData.NAME
            this.postForm.code = rowData.CODE
            this.postForm.note = rowData.NOTE

            // 通过当前ID请求更多的数据
            // this.getRoleDetail(rowData.CODE)
        },
        // 弹出“删除角色”确认框
        showDelDialog(data) {

            const rowData = JSON.parse(JSON.stringify(data.row))

            // 通过当前ID请求更多的数据
            // this.getRoleDetail(rowData.CODE)
            var delParams = {
                code: rowData.CODE
            }
            var $this = this
                this.$confirm('删除角色将无法恢复，确定操作吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                $this.delRole(delParams, '删除成功！')
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除操作'
                })
            })
        },
        
        // 删除角色
        delRole (params, msg) {
            delRoleReq(params)
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    this.$message.success(msg)
                    this.getRoleList()
                })
                .catch(e => {
                    console.log(e);
                })
        },

        // 弹窗关闭前
        beforeClose() {
            this.resetData()
        },
        // 关闭弹窗
        closeDialog() {
            this.resetData()
        },
        // 重置表单
        resetData() {
            this.dialogFormVisible = false
            this.$nextTick(() => {
                this.$refs['form'].clearValidate()
            })
            this.postForm = Object.assign({}, defaultPostForm)
        },

        // 验证表单-点击弹窗的“确定”按钮
        validateForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitForm()
                } else {
                    this.dialogFormVisible = true
                }
            })
        },
        // 提交表单
        async submitForm() {
            const params = {
                code: this.postForm.code,
                name: this.postForm.name,
                note: this.postForm.note,
            }
            let message = '';
            if (this.dialogTitle === 'add') {
                // this.addRole();
                message = '添加角色成功'
                params.update = 'false'
                
            } else if (this.dialogTitle === 'edit') {
                // this.editRole();
                message = '编辑角色成功'
                params.update = 'true'
            }
            try {
                const result = await addOrEditRoleReq(params)
                this.closeDialog()
                this.getRoleList()
                this.$message.success(message)
            } catch (e) {
                console.log(e)
            }
        },
        





        
        // 授权弹窗-弹出角色“授权”窗口
        showAuthDialog(data) {
            // this.authDialogTitle = 'auth'
            // this.authDialogFormVisible = true

            const rowData = data.row
            // 通过当前Code获取角色授权详情数据
            this.searchAuthRoleForm.code = rowData.CODE
            this.authSubmitForm.code = rowData.CODE
            // 授权弹窗-获取角色授权列表(表格数据)
            this.getRoleByCode()
            // 授权弹窗-获取角色已授权的总数（表格数据已勾选的总数）
            this.getRoleAuthTotal()

            this.authDialogTitle = 'auth'
            this.authDialogFormVisible = true
            
        },
        // 授权弹窗-获取角色授权列表(表格数据)
        getRoleByCode () {
            // 初始化勾选数据
            this.checkedGouArrData = []

            getRoleByCodeReq(this.searchAuthRoleForm)
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    this.authRoleTableData = resp.body.rows
                    this.authRoleTotal = parseInt(resp.body.total)
                    const authRoleTableIdData = []
                    this.authRoleTableData.filter((rowData) => {
                        if(rowData.CHECKED == '1'){
                            this.checkedGouArrData.push(rowData)
                        }
                        authRoleTableIdData.push(rowData.ID)
                    })

                    const checkedGouArrIdData = []
                    this.checkedGouArrData.filter((rowData) => {
                        checkedGouArrIdData.push(rowData.ID)
                    })

                    console.log('this.addAuthPersonnel', this.addAuthPersonnel)
                    console.log('this.delAuthPersonnel', this.delAuthPersonnel)
                    console.log('this.checkedGouArrData', this.checkedGouArrData)
                    if (this.addAuthPersonnel.length > 0) {
                        // console.log('this.addAuthPersonnel.length>0', '')
                        this.addAuthPersonnel.forEach(item =>{
                            // let addIndex = this.checkedGouArrData.indexOf(item)
                            // let tableIndex = this.authRoleTableData.indexOf(item)
                            // 不知道为什么用数组的完整项匹配不到坐标，只能用每项中的唯一值ID去匹配
                            let addIndex = checkedGouArrIdData.indexOf(item.ID)
                            let tableIndex = authRoleTableIdData.indexOf(item.ID)
                            // 加入之前手动勾选的数据（即让添加授权数组的每一项去比对符合“当前页的表格数组中存在”且“回显数组中不存在”的条件的项，再添加这一项到回显数组）
                            // if(addIndex == -1) { 
                            if(addIndex == -1 && tableIndex != -1) { 
                                this.checkedGouArrData.push(item)
                                console.log('this.checkedGouArrData-push', this.checkedGouArrData)
                            }
                        })
                    }

                    if (this.delAuthPersonnel.length > 0) {
                        // console.log('this.delAuthPersonnel.length>0', '')
                        this.delAuthPersonnel.forEach(item =>{
                            // let delIndex = this.checkedGouArrData.indexOf(item)
                            // let tableIndex = this.authRoleTableData.indexOf(item)
                            // 不知道为什么用数组的完整项匹配不到坐标，只能用每项中的唯一值ID去匹配
                            let delIndex = checkedGouArrIdData.indexOf(item.ID)
                            let tableIndex = authRoleTableIdData.indexOf(item.ID)
                            // 加入之前手动勾选的数据（即让删除授权数组的每一项去比对符合“当前页的表格数组中存在”且“回显数组中存在”的条件的项，再从回显数组删去这一项）
                            // if(delIndex != -1 && tableIndex != -1) { 
                            if(delIndex != -1) { 
                                this.checkedGouArrData.splice(delIndex, 1);
                                console.log('this.checkedGouArrData-splice', this.checkedGouArrData)
                            }
                        })
                    }

                    // 显示勾选表格行事件
                    // setTimeout(() => {
                    //     this.toggleSelection(this.checkedGouArrData)
                    // }, 100);
                   
                    this.$nextTick(() => {
                        this.toggleSelection(this.checkedGouArrData)
                    })
                    
                })
                .catch(e => {
                    console.log(e);
                })
        },
        // 授权弹窗-获取角色已授权的总数（表格数据已勾选的总数）
        getRoleAuthTotal() {
            // 初始化角色授权表格打开时已勾选数据总数
            this.checkedGouArrDataTotalForTable = 0
            // 初始化角色授权表格当前已勾选数据总数
            this.checkedGouArrDataTotal = 0

            const param = {
                code: this.searchAuthRoleForm.code
            }

            getRoleAuthTotalReq(param)
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    // 显示“已勾选”的数量（此时显示查询回来的勾选总数）
                    this.checkedGouArrDataTotalForTable = resp.num
                    if(!resp.num){
                        this.checkedGouArrDataTotalForTable = 0
                    }
                    this.checkedGouArrDataTotal = this.checkedGouArrDataTotalForTable
                })
                .catch(e => {
                    console.log(e);
                })

        },
        // 显示勾选表格行事件
        toggleSelection(rows) {
            if(rows) {
                console.log('rows.length', rows.length)
            }
            if (rows) {
                rows.forEach(row => {
                    this.$refs.authDTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.authDTable.clearSelection();
            }
        },

        // 授权弹窗-列表过滤查询
        handleSearch2() {
            this.searchAuthRoleForm.page = 1
            this.getRoleByCode()
        },
        // 授权弹窗-搜索重置（清空）
        handleReset2() {
            // 初始化参数
            // this.searchAuthRoleForm = Object.assign({}, defaultSearchAuthRoleForm)
            this.searchAuthRoleForm.userAccountOrName = ''
            this.searchAuthRoleForm.parentName = ''
            // 获取表格数据
            this.getRoleByCode()
        },
        // 授权弹窗-列表每页条数变了
        handleSizeChange2(val) {
            this.searchAuthRoleForm.rows = val
            this.getRoleByCode()
        },
        // 授权弹窗-列表当前页码变了
        handleCurrentChange2(val) {
            this.searchAuthRoleForm.page = val
            this.getRoleByCode()
        },

        // 授权弹窗关闭前
        beforeCloseAuth() {
            this.resetAuthData()
        },
        // 关闭授权弹窗
        closeAuthDialog() {
            this.resetAuthData()
        },
        // 重置授权表单
        resetAuthData() {
            this.authDialogFormVisible = false
            // 初始化参数
            this.searchAuthRoleForm = Object.assign({}, defaultSearchAuthRoleForm)
            // 初始化“添加授权的人员数组”，“取消授权的人员数组”
            this.addAuthPersonnel = []
            this.delAuthPersonnel = []
            // 初始化 角色授权表格打开时已勾选数据总数
            this.checkedGouArrDataTotal = 0
            // 初始化勾选数组（不勾选）
            setTimeout(() => {
                this.toggleSelection()
            }, 100);
            // this.$nextTick(() => {
            //     this.toggleSelection()
            // })
        },

        // 验证授权表单-点击弹窗的“确定”按钮
        validateAuthForm() {
            if(this.authDialogTitle = 'auth') {
                // 批量授权
                // const idAuthGroups = this.sels.map(item => ({userId: item.ID}))
                const idAddAuthGroups = this.addAuthPersonnel.map(item => ({userId: item.ID}))
                const idDelAuthGroups = this.delAuthPersonnel.map(item => ({userId: item.ID}))
                
                const authParams = {
                    code: this.authSubmitForm.code,
                    addRowsArr: idAddAuthGroups,
                    // delRowsArr: idDelAuthGroups
                }

                // console.log('authParams', authParams)
                this.submitAuthForm(authParams)
            }
        },
        // 提交授权表单
        submitAuthForm(authParams, delAuthParams) {
            // 先给角色添加授权人员
            authRoleReq(authParams)
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    this.getRoleList()
                    this.closeAuthDialog()
                    // this.$message.success(msg)
                    this.$message.success('授权成功！')
                })
                .catch(e => {
                    console.log(e);
                })
        },
        



        // 角色授权详情弹窗-弹出角色“授权详情”窗口
        showAuthDetailDialog(data) {
            this.authDetailDialogTitle = '授权详情'
            this.authDetailDialogFormVisible = true

            // 通过当前Code获取角色授权详情数据
            const rowData = data.row
            this.searchAuthDetailForm.code = rowData.CODE
            this.getAuthDetailRole()
        },
        // 角色授权详情弹窗-获取角色授权详情(表格数据)
        getAuthDetailRole () {
            getAuthDetailRoleReq(this.searchAuthDetailForm)
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    this.authRoleDetailTableData = resp.body.rows
                    this.authRoleDetailTotal = parseInt(resp.body.total)
                })
                .catch(e => {
                    console.log(e);
                })
        },
        
        // 角色授权详情弹窗-列表过滤查询
        handleSearch3() {
            this.searchAuthDetailForm.page = 1
            this.getAuthDetailRole()
        },
        // 角色授权详情弹窗-搜索重置（清空）
        handleReset3() {
            // 初始化参数
            // this.searchAuthDetailForm = Object.assign({}, defaultSearchAuthDetailForm)
            this.searchAuthDetailForm.userAccountOrName = ''
            this.searchAuthDetailForm.parentName = ''
            // 获取表格数据
            this.getAuthDetailRole()
        },
        // 角色授权详情弹窗-列表每页条数变了
        handleSizeChange3(val) {
            this.searchAuthDetailForm.rows = val
            this.getAuthDetailRole()
        },
        // 角色授权详情弹窗-列表当前页码变了
        handleCurrentChange3(val) {
            this.searchAuthDetailForm.page = val
            this.getAuthDetailRole()
        },

        // 授权详情弹窗关闭前
        beforeCloseAuthDetail() {
            this.resetAuthDetailData()
        },
        // 关闭授权详情弹窗
        closeAuthDetailDialog() {
            this.resetAuthDetailData()
        },
        // 重置授权详情表单
        resetAuthDetailData() {
            this.authDetailDialogFormVisible = false
            // 初始化参数
            this.searchAuthDetailForm = Object.assign({}, defaultSearchAuthDetailForm)
            // this.$nextTick(() => {
            //     this.$refs['authDetailForm'].clearValidate()
            // })
            // this.postAuthDetailForm = Object.assign({}, defaultPostAuthDetailForm)
        },
        // 验证授权表单-点击弹窗的“确定”按钮
        validateAuthDetailForm() {
            this.resetAuthDetailData()
        },




        // ----------以下是-tab角色权限配置----------以下是-tab角色权限配置-----------以下是-tab角色权限配置----------------以下是-tab角色权限配置----------以下是-tab角色权限配置-----------

        // 获取角色数据
        getAllRoleData () {
            // 角色数据
            getAllRoleDataReq()
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    this.roleData.roleArr = resp.body.rows
                })
                .catch(e => {
                    console.log(e);
                })
        },
        // 角色选择切换
        changeRole(index, code) {
            this.roleData.roleIndex = index;
            // console.log('changeRole-index', index)

            // 初始化
            this.authGroupCode = null
            // 授权、取消授权参数中的group_code
            this.authGroupCode = code
            // console.log('this.authGroupCode', this.authGroupCode)

            // 获取右边要勾选的授权信息
            // 根据点击左边的角色获取右面要显示勾选数据
            this.getAuthIsGouByRole(code)

        },
        // 角色管理-根据用户获取用户拥有的功能权限 (根据点击左边的角色获取右面要显示勾选数据) 
        getAuthIsGouByRole (code) {
            const parma = {
                GROUP_CODE: code
            }
            getAuthIsGouByRoleReq(parma)
                .then(resp => {
                    // if (!resp) {
                    //     this.$message.error(resp.header.message)
                    //     return
                    // }
                    if (resp.length == 0) {
                        this.$message.error('该角色没有已授权的选项')
                        let nullArr = [];
                        // 授权树全都不勾选
                        this.$refs.tree.setCheckedKeys(nullArr)
                        return
                    }

                    let arr = [];//定义一个新数组存放回显需要的数据
                    for (let item of resp) {
                        // 授权勾选的标识：id对应的是权限树菜单中的id
                        item.id = item.MODULE_PATH + item.RES_PATH
                        arr.push(item.id)
                    }
                    // console.log('arr', arr)
                    // 显示树勾选
                    this.$refs.tree.setCheckedKeys(arr)


                    // let newArr = []; //定义一个新数组存放新数据
                    // newArr = resp;

                    // let fdStart = null; 
                    // let fdEnd1 = null;
                    // let fdEnd2 = null;
                    // // console.log('newArr-1', newArr)
                    // resp.forEach(value =>{
                    //     fdStart = value.RES_PATH.indexOf('~view'); 
                    //     fdEnd1 = value.RES_PATH.lastIndexOf('.html'); 
                    //     fdEnd2 = value.RES_PATH.lastIndexOf('.ftl'); 
                        
                    //     if(fdStart == 0) {
                    //         // 表示是以'~view'开头
                    //         // console.log('开头是~view')
                    //         // console.log('fdEnd1', fdEnd1)
                    //         // console.log('fdEnd2', fdEnd2)
                    //         if (fdEnd1 == -1 && fdEnd2 == -1) {
                    //             // 结尾没有后缀(此时要添加一项给结尾加上'.ftl'的当前项)
                    //             // console.log('结尾没有后缀')
                    //             const newStr1 = {}

                    //             newStr1.RES_PATH = value.RES_PATH + '.ftl'
                    //             newStr1.MODULE_PATH = value.MODULE_PATH
                    //             newStr1.GROUP_CODE = value.GROUP_CODE
                    //             newArr.push(newStr1);
                    //         } else if (fdEnd1 != -1) {
                    //             // 结尾有后缀'.html'(此时要添加一项给结尾删去'.html'的当前项)
                    //             // console.log('结尾有后缀html')
                    //             const newStr2 = {}
                                
                    //             var a= value.RES_PATH;
                    //             a= a.substring(0,a.lastIndexOf('.html'));
                    //             newStr2.RES_PATH = a
                    //             newStr2.MODULE_PATH = value.MODULE_PATH
                    //             newStr2.GROUP_CODE = value.GROUP_CODE
                    //             newArr.push(newStr2);
                    //         } else if (fdEnd2 != -1) {
                    //             // 结尾有后缀'.ftl'(此时要添加一项给结尾删去'.ftl'的当前项)
                    //             // console.log('结尾有后缀ftl')
                    //             const newStr3 = {}

                    //             var b= value.RES_PATH;
                    //             b= b.substring(0,b.lastIndexOf('.ftl'));
                    //             newStr3.RES_PATH = b
                    //             newStr3.MODULE_PATH = value.MODULE_PATH
                    //             newStr3.GROUP_CODE = value.GROUP_CODE
                    //             newArr.push(newStr3);
                    //         }
                    //     } else if (fdStart == -1) {
                    //         //  表示不是以'~view'开头
                    //         // 此时不作处理
                    //     }
                    // })
                    // // console.log('newArr-2', newArr)


                    // let isGouDataArr = newArr
                    // // console.log('isGouDataArr', isGouDataArr)

                    // let arr = [];
                    // for (let item of isGouDataArr) {
                    //     // 授权勾选的标识：RES_PATH对应的是权限树菜单中的id
                    //     arr.push(item.RES_PATH)
                    //     // // MODULE_PATH对应的是权限树菜单中的value
                    // }
                    // // console.log('arr', arr)
                    // // 显示树勾选
                    // this.$refs.tree.setCheckedKeys(arr)
                })
                .catch(e => {
                    console.log(e);
                })
        },

        // 授权菜单树形数据
        getAuthTree () {
            getAuthTreeReq()
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    this.authTreeData = resp.body
                })
                .catch(e => {
                    console.log(e);
                })
        },
        // 搜索授权选项
        searchTree() {

        },



        /**
         * 根据url拆分参数
         */
        transformAuthParam(url) {
            // var url = "!Report/~/pages/salesPlatform.jsp";
            var x = url.indexOf("~");
            var i = url.indexOf("?");
            var preStr = url.substring(1, x - 1);
            var lastStr;
            if (i == -1) {
                lastStr = url.substring(x);
            }else{
                lastStr = url.substring(x, i);
            }
            var newArr = {
                module_path: preStr,
                res_path: lastStr
            };
            return newArr;
        },


        
        // 授权树-节点勾选状态发生变化时的回调
        authTreeCheckChange(data, checked, indeterminate) {
            // console.log('···········································',)
            // console.log('authTreeCheckChange-checked', checked)
            // console.log('authTreeCheckChange-data', data)
            if (checked == true) {
                if (data.submenus.length==0){
                    let addPros = this.transformAuthParam(data.url);
                    this.authAddArr.push(addPros);
                    // console.log('checked-this.authAddArr', this.authAddArr)
                }
            } else if (checked == false) {
                if (data.submenus.length==0){
                    let delPros = this.transformAuthParam(data.url);
                    this.authDelArr.push(delPros);
                    console.log('checked-this.authDelArr', this.authDelArr)
                }
            }

        },
        
        // 提交授权
        finallyAuth() {
            // 先把group_code数据插入到授权/取消授权的数组中
            let group_code = null;
            if(this.authGroupCode) {
                group_code = this.authGroupCode
            }
            for(let i in this.authAddArr){
                this.authAddArr[i].group_code = group_code
            }
            for(let i in this.authDelArr){
                this.authDelArr[i].group_code = group_code
            }
            // console.log('this.authAddArr111', this.authAddArr)
            // console.log('this.authDelArr111', this.authDelArr)
            
            // 找出两个数组中的相同项的坐标，替换成“？”
            for(let i=0; i<this.authAddArr.length; i++) {
                for (let j=0; j<this.authDelArr.length; j++) {
                    if (this.authDelArr[j].res_path == this.authAddArr[i].res_path) {
                        this.authDelArr[j] = '?'
                        this.authAddArr[i] = '?'
                    }
                    
                }
            }
            // console.log('this.authAddArr222', this.authAddArr)
            // console.log('this.authDelArr222', this.authDelArr)

            // 再移除两个数组中的“？”项
            const newAdd = this.authAddArr
            for(let i=0; i<newAdd.length; i++) {
                if(newAdd[i] == '?') {
                    newAdd.splice(i, 1)
                    i--;
                }
            }
            const newDel = this.authDelArr
            for(let i=0; i<newDel.length; i++) {
                if(newDel[i] == '?') {
                    newDel.splice(i, 1)
                    i--;
                }
            }
            // console.log('newAdd', newAdd)
            // console.log('newDel', newDel)

            // 授权
            this.addAuth(newAdd, newDel)

            // 初始化数组
            this.authAddArr = []
            this.authDelArr = []
        },
        // 授权 树
        addAuth (newAdd, newDel) {
            const param = {
                addRowsArr: newAdd
            }
            addAuthReq(param)
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    // this.$message.success('授权成功')
                    // 取消授权
                    this.cancelAuth(newDel)
                })
                .catch(e => {
                    console.log(e);
                })
        },
        // 取消授权 树
        cancelAuth (newDel) {
            const param = {
                delRowsArr: newDel
            }
            cancelAuthReq(param)
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    // this.$message.success('取消授权成功')
                    // 确定授权
                    this.confirmAddAuth()
                })
                .catch(e => {
                    console.log(e);
                })
        },
        // 确定授权
        confirmAddAuth () {
            confirmAddAuthReq()
                .then(resp => {
                    if (resp.header && resp.header.code != 0) {
                        this.$message.error(resp.header.message)
                        return
                    }
                    this.$message.success('授权提交成功')
                    // 初始化(左边)角色点击时存储的数据
                    this.roleData.roleArr = []
                    this.roleData.roleIndex = null
                    // 初始化(右边)授权树的勾选数据（授权树全都不勾选）
                    let nullArr = [];
                    this.$refs.tree.setCheckedKeys(nullArr)
                    // 再重新获取页面数据
                    this.getAllRoleData()
                    this.getAuthTree()
                })
                .catch(e => {
                    console.log(e);
                })
        },
        
        // 授权树点击
        authTreeClick(data) {
            // console.log('authTreeClick-data', data)
            // console.log('authTreeClick-label', data.label)
            // console.log('authTreeClick-labelId', data.labelId)
            // console.log('authTreeClick-children', data.children)
        },
        // 授权树-当前被点击节点变化时触发的事件
        authCurrentCheckChange(data, checked, indeterminate) {
            // console.log('authCurrentCheckChange-data', data)
        },





    },
    
    
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* 文字顔色 */
.greenText {
    color: #2DBAA5;
}
.lightGText {
    color: #76C819;
}
.orangeText {
    color: #FA6241;
}
.grayText {
    color: #7F7F7F;
}

// 批量操作
.batchSel {
    width: 130px;
    margin-right: 5px;
}
.orangeBtn {
    color: #FFFFFF !important;
    background-color: #FA6241;
    &:hover {
        background-color: rgb(247, 143, 120);
    }
}
// 按钮
.el-button {
}
.greenBtn {
    color: #FFFFFF !important;
    background-color: #2DBAA5;
    &:hover {
        background-color: rgb(115, 196, 183);
    }
}




.roleManage {
    min-width: 1080px;
}

// tab切换-角色管理、角色权限配置
.roleManage .tabBox {
    padding-left: 4px;
    background: #fff;
    height: 40px;
    line-height: 40px;
    text-align: center;
}
.tabBox li {
    float: left;
    width: 90px;
    color: #7F7F7F;
    font-size: 13px;
    font-weight: bold;
    cursor: pointer;
    position: relative;
}
.tabBox li+li {
    margin-left: 10px;
}
.tabBox li.on {
    color: #F99A1A;
}
.tabBox li:after {
    content: '';
    position: absolute;
    width: 90px;
    height: 4px;
    background: transparent;
    bottom: -4px;
    left: 0;
}
.tabBox li.on:after {
    background: #F99A1A;
}


// tab内容区
.roleManage .tabContent {
    
}

// tab内容区-角色管理
// 角色管理
.roleManage .tabContent.manageArea {
    
}
// 角色管理-表格
.roleManage .tabContent.manageArea .botTable {
    width: 100%;
    margin-top: 14px;
}
.botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
}
.botTable .tableTop .leTableTit {
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
}
.botTable .tableTop .rightBox {
    width: auto;
    min-width: 200px; //考虑是否删去
    text-align: right;
    display: inline-block;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
}




// tab内容区-角色权限配置
.roleManage .tabContent.mainBox {

}
.roleManage .tabContent.mainBox {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
}

// 角色权限配置-左边
.mainBox .le_main {
    width: 312px;
    min-height: 616px;
    // min-height: 716px;
    height: 100%;
    background: #ffffff;
    padding: 12px 9px 8px 4px;
    display: flex;
    flex-flow: column nowrap;
}

.mainBox .le_main .titleBox {
    width: 100%;
    height: 17px;
    line-height: 17px;
    background: #fff;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    // align-items: center;
}
.mainBox .le_main .titleBox i.roleIcon {
    display: inline-block;
    margin-left: 6px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    background: url('../../../assets/images/system/roleManage/roleIcon.png') no-repeat;
    background-size: 100% 100%;
}
.mainBox .le_main .titleBox span {
    margin-left: 4px;
    color: #4E4A46;
    font-size: 13px;
    font-weight: bold;
}


.mainBox .le_main .content {
    margin-top: 10px;
    width: 100%;
    height: 640px;
    min-height: 640px;
    max-height: 640px;
    background: #F5F5F5;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
}
.mainBox .le_main .content.roleBox {
    padding-top: 8px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: auto;
}
.roleBox .roleUlBox {
    width: 100%;
    height: 100%;
}
.roleBox .roleUlBox li {
    width: 100%;
    height: 24px;
    line-height: 24px;
    padding-left: 11px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}
.roleBox .roleUlBox li.on {
    background: #FAFAFA;
}
.roleBox .roleUlBox li+li {
    margin-top: 2px;
}
.roleBox .roleUlBox li i.roleHead {
    width: 16px;
    height: 16px;
    line-height: 16px;
    background: url('../../../assets/images/system/PersonnelManage/roleHeadOff.png') no-repeat;
    background-size: 100% 100%;
}
.roleBox .roleUlBox li.on i.roleHead {
    width: 16px;
    height: 16px;
    line-height: 16px;
    background: url('../../../assets/images/system/PersonnelManage/roleHeadOn.png') no-repeat;
    background-size: 100% 100%;
}
.roleBox .roleUlBox li span.roleName {
    width: calc(100% - 16px - 4px);
    margin-left: 4px;
    height: 16px;
    line-height: 16px;
    color: #4E4A46;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.roleBox .roleUlBox li.on span.roleName {
    color: #FA6241;
}


// 角色权限配置-右边
.mainBox .ri_main {
    width: calc(100% - 312px - 12px);
    margin-left: 12px;
    min-width: 600px;
    height: auto;
    // height: 100%;
    background: #ffffff;
    padding: 6px 12px 8px;
    display: flex;
    flex-flow: column nowrap;
}

.mainBox .ri_main .topBox {
    width: 100%;
    height: auto;
    height: 32px;
    background: #fff;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    // align-items: center;
    
}
.mainBox .ri_main .topBox .leTit {
    margin-top: 9px;
    height: 17px;
    line-height: 17px;
    color: #4E4A46;
    font-size: 13px;
    font-weight: bold;
}
.mainBox .ri_main .topBox .riFilter {
    width: auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
}
.mainBox .ri_main .topBox .riFilter .btn-search {
    margin-left: 5px;
    background-color: #FA6241;
    color: #fff;
    &:hover {
        background-color: rgb(247, 143, 120);
    }
}

.mainBox .ri_main .treeContent {
    margin-top: 10px;
    width: 100%;
    // height: 100%;
    min-height: 640px;
    // max-height: 680px;
    background: #F5F5F5;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
}









/* 分页条 */
.pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
}
/* 弹窗-分页条 */
.pageBox2 {
    width: 100%;
    padding: 10px 0 10px 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
}

// 弹窗按钮-取消按钮
.cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
}

// 弹窗按钮-橙色按钮
.refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;
    &:hover {
      background-color: rgb(247, 143, 120);
    }
}


// 弹窗筛选框
.filtBox2 {
    margin: 0px 0px 10px 0px;
    padding: 0px;
    background: #ffffff;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
}
.filtBox2 .el-form {
    width: 100%;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    padding-top: 18px;
    .el-input {
        // 原来的宽度
        width: 160px !important;
    }
    .el-select {
        // 原来的宽度
        width: 160px !important;
    }
}
.filtBox2 .btnArea{
      float: right;
}
.filtBox2 .el-button {
    border-radius: 4px;
    padding: 11px 15px;
    border: none;
}
.filtBox2 .btn-search {
    background-color: #FA6241;
    color: #fff;
    &:hover {
        background-color: rgb(247, 143, 120);
    }
}
.filtBox2 .btn-reset {
    background-color: #F99A1A;
    color: #fff;
    &:hover {
        background-color: rgb(248, 186, 105);
    }
}


</style>
